if (typeof CollapsibleContent !== 'function') {
	class CollapsibleContent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				accordionQuestion: 'collapsible-row__question',
				accordionItem: '.collapsible-row',
			};

			this.elements = {
				accordionQuestion: this.querySelectorAll(this.selectors.accordionQuestion),
				accordionItem: this.querySelectorAll(this.selectors.accordionItem),
			};

			this.classes = {
				accordionItemActive: 'collapsible-row--active',
			};

			this.init();
		}

		init() {
			this.elements.accordionItem.forEach((item) => {
				item.addEventListener('click', () => {
					if (this.dataset.settings == 'close-others') {
						this.closeOthers(item);
					}

					item.classList.toggle(this.classes.accordionItemActive);
				});
			});
		}

		closeOthers(currentItem) {
			this.elements.accordionItem.forEach((item) => {
				if (item !== currentItem) {
					item.classList.remove(this.classes.accordionItemActive);
				}
			});
		}
	}

	if (typeof customElements.get('collapsible-content') == 'undefined') {
		customElements.define('collapsible-content', CollapsibleContent);
	}
}
